export default __webpack_public_path__ + "static/6_23-7056c92ae3aaf341dc01f600c040242f.png";